export default __webpack_public_path__ + "assets/team-component.6eeab610.svg";